/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Privacy_P2Inputs */

const en_pc_online_privacy_p2 = /** @type {(inputs: Pc_Online_Privacy_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can check this yourself: open your browser's developer tools, switch to the Network tab and open a PDF. Once the app has loaded, no request carries your document.`)
};

const zh_pc_online_privacy_p2 = /** @type {(inputs: Pc_Online_Privacy_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以自己验证：打开浏览器开发者工具，切换到「网络」面板，然后打开一个 PDF。应用加载完成后，没有任何请求会携带你的文档。`)
};

/**
* | output |
* | --- |
* | "You can check this yourself: open your browser's developer tools, switch to the Network tab and open a PDF. Once the app has loaded, no request carries your ..." |
*
* @param {Pc_Online_Privacy_P2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_privacy_p2 = /** @type {((inputs?: Pc_Online_Privacy_P2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Privacy_P2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_privacy_p2(inputs)
	return zh_pc_online_privacy_p2(inputs)
});
export { pc_online_privacy_p2 as "pc.online.privacy_p2" }